var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    fill: "none",
    height: 110,
    viewBox: "0 0 110 110",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 55C0 40.4131 5.79463 26.4236 16.1091 16.1091C26.4236 5.79463 40.4131 0 55 0C69.5869 0 83.5764 5.79463 93.8909 16.1091C104.205 26.4236 110 40.4131 110 55C110 69.5869 104.205 83.5764 93.8909 93.8909C83.5764 104.205 69.5869 110 55 110C40.4131 110 26.4236 104.205 16.1091 93.8909C5.79463 83.5764 0 69.5869 0 55H0ZM51.8613 78.54L83.5267 38.9547L77.8067 34.3787L50.8053 68.1193L31.68 52.184L26.9867 57.816L51.8613 78.5473V78.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.afc2ca94a28f4cb5c2bdaf7f29b93144.svg";
export { ForwardRef as ReactComponent };